import { v4 as uuidv4 } from 'uuid';
export const interpolateRoute = (target, params) => {
    const optionalParameterRegex = /\/:.*?\?/gi;
    const optionalSegmentRegex = /\/[a-z]*?\?/gi;
    const parenthesisRegex = / *\([^)]*\) */gi;
    let result = target;
    Object.keys(params).forEach((key) => {
        const value = params[key];
        const isString = typeof value === 'string';
        const isNumber = Number.isFinite(value);
        const isUndefined = value === undefined;
        if (!(isString || isNumber || isUndefined)) {
            throw new Error(`Value for key ${key} is invalid: ${value}`);
        }
        const optionalParamRoute = `:${key}?`;
        const paramRoute = `:${key}`;
        if (!target.includes(paramRoute)) {
            throw new Error(`Cannot find placeholder ${key}`);
        }
        // Removes parenthesis E.g. (invc_\\S+)?
        result = result.replace(parenthesisRegex, '');
        const sanitisedValue = (value && value.toString()) || '';
        if (value) {
            result = result.replace(optionalParamRoute, sanitisedValue);
            result = result.replace(paramRoute, sanitisedValue);
        }
        const optionalSegment = result.match(optionalSegmentRegex);
        if (optionalSegment) {
            const newOptionalSegment = optionalSegment[0].replace('?', '');
            result = result.replace(optionalSegment[0], newOptionalSegment);
        }
    });
    return result.replace(optionalParameterRegex, '').replace(optionalSegmentRegex, '');
};
export const getRandomString = (length = 16) => {
    const sanitisedLength = length > 0 ? length : 16;
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < sanitisedLength; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};
export const getRandomUUID = () => uuidv4();
export const capitalizeFirstLetter = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1);
};
export const inflectString = (num, word) => (num === 1 ? word : `${word}s`);
